/**
 * Profile service for @ollaid/native-sso
 * Updates the authenticated profile fields via IAM.
 *
 * @version 2.7.9
 */

import { fetchWithTimeout, getAuthToken, getHeaders, getIamApiBaseUrl, ensureDeviceContext } from './api';
import type { UserInfos } from '../types/native';

export interface ProfileUpdateRequest {
  name?: string;
  ccphone?: string;
  phone?: string;
  email?: string;
  address?: string;
  town?: string;
  country?: string;
}

export interface ProfileUpdateResponse {
  message?: string;
  user?: UserInfos;
  user_infos?: UserInfos;
}

export interface ProfileFetchResponse {
  message?: string;
  user?: UserInfos;
  user_infos?: UserInfos;
}

export const profileService = {
  async getProfile(): Promise<ProfileFetchResponse> {
    const baseUrl = getIamApiBaseUrl();
    const token = getAuthToken();
    if (!token) {
      throw new Error('Token manquant');
    }

    await ensureDeviceContext();

    return fetchWithTimeout<ProfileFetchResponse>(
      `${baseUrl}/backoffice/profile`,
      {
        method: 'GET',
        headers: getHeaders(token, false),
      },
      20000
    );
  },

  async updateProfile(data: ProfileUpdateRequest): Promise<ProfileUpdateResponse> {
    const baseUrl = getIamApiBaseUrl();
    const token = getAuthToken();
    if (!token) {
      throw new Error('Token manquant');
    }

    await ensureDeviceContext();

    return fetchWithTimeout<ProfileUpdateResponse>(
      `${baseUrl}/backoffice/profile`,
      {
        method: 'PUT',
        headers: getHeaders(token, false),
        body: JSON.stringify(data),
      },
      30000
    );
  },
};

export default profileService;
